import { Component, Input, Output, ViewChild, EventEmitter, ElementRef, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from '../../services/dashboard.service';

@Component({ standalone: false,
  selector: 'vfa-cp-modal-pdf',
  templateUrl: './modal-pdf.component.html',
  styleUrls: ['./modal-pdf.component.scss'],
})
export class ModalPdfComponent {
  @Input() configs: any;
  @Output() pressCheck: EventEmitter<any> = new EventEmitter();
  public pdfSrc: any;
  public wait = false;
  public disableCheck = true;
  private blobPDF: any;
  private setScrollEventListner = false;
  public isImage = false;

  @ViewChild('modalPdf') modalPdf: any;

  constructor(private modalService: NgbModal,
              private dashboardService: DashboardService) {}

  public openModal(check :boolean, isImage? :boolean) {
    if (this.configs && this.configs.url) {
      this.isImage = isImage? isImage : false;
      this.configs.check = check;
      this.setScrollEventListner = false;
      this.downloadFilePdf();
      this.modalService.open(this.modalPdf, { keyboard: false, centered: true, size: 'xl', backdropClass: "bg-modal" });
    }
  }

  public closeModal() {
    this.modalService.dismissAll();
  }
  
  private downloadFilePdf() {
    this.wait = true;
    this.dashboardService.downloadFilePdf(this.configs.url).subscribe(res => {      
      this.blobPDF = new Blob([res], { type: 'application/pdf' });
      const fileReader = new FileReader();
      fileReader.onload = () => {
          this.pdfSrc = new Uint8Array(fileReader.result as ArrayBuffer);
          this.wait = false;
      };
      fileReader.readAsArrayBuffer(this.blobPDF);
      this.wait = false;
    }, err => {
      this.dashboardService.showToast(this.dashboardService.getError(err), "danger");
      this.wait = false;
    })
  }

  public afterLoadComplete(evt:any):void {
    const targetElement = document.querySelector(".ng2-pdf-viewer-container");
    if (this.configs && this.configs.check && !this.setScrollEventListner && targetElement) {
      this.setScrollEventListner = true;
      let lastScrollTop = 0;
      targetElement.addEventListener('scroll', (event:any) => {
        if (event.target.scrollTop < lastScrollTop){              
              return; // upscroll
          } 
          lastScrollTop = event.target.scrollTop <= 0 ? 0 : event.target.scrollTop;
          if ((Math.ceil(event.target.scrollTop) + event.target.offsetHeight) >= (event.target.scrollHeight * 0.999) ){
            this.disableCheck = false;
          }
      });
    }
  };

  public downloadPhysicalPdf() {    
    if (this.blobPDF && this.blobPDF.size !== 0) {
        const file: any = {};
        file.nomeFile = this.configs.filename ? this.configs.filename : 'VFA_CUSTOMER.pdf';
        file.urlFile = window.URL.createObjectURL(this.blobPDF);
        const link = document.createElement('a');
        link.href = file.urlFile;
        link.download = file.nomeFile;
        link.click();
    }
  }

  public checkPdf() {
    this.pressCheck.emit(true);
    this.modalService.dismissAll();
  }
  
}

